module.exports = __webpack_public_path__ + "static/media/opakowania_4_B.8a0d5b61.png";